<template>
    <div class="teaekwondo-content">
        <FightContent v-if="technicalDetails&&actionTrack=='match_taekwondo_elimination'||actionTrack=='match_karate_kumite'" :eWidth="430" :eHight="150" :actionTrack="actionTrack"  :technicalDetails="technicalDetails"/>
        <GradeContent v-else-if="technicalDetails&&actionTrack=='match_taekwondo_score_rounds,match_vs_score_log'" :technicalDetails="technicalDetails"/>
        <!-- 举旗 -->
        <template v-else-if="technicalDetails&&actionTrack=='match_taekwondo_sample_rounds,match_taekwondo_sample'||actionTrack=='match_karate_sample_rounds,match_karate_sample'&&!isDetail">
            <SampleContent  :scoreDetail="technicalDetails"/>
        </template>
        <template v-else>
            <SampContentDetail :scoreDetail="technicalDetails"/>
        </template>
      
    </div>
</template>

<script>
import FightContent from './content/FightContent.vue'
import GradeContent from './content/GradeContent.vue'
import SampleContent from './content/SampleContent.vue'
import SampContentDetail from './content/SampContentDetail.vue'
export default {
  name:'TaekwondoModalContent', 
  props:['technicalDetails','actionTrack'],
  components:{FightContent,GradeContent,SampleContent,SampContentDetail},
  data () {
    return {
      isDetail:false
    }
  },
  methods: {
    showData (){
    }
  },
  mounted () {
    this.showData()
  },
  computed: {
    
  },
}
</script>

<style lang="scss" scoped>
.teaekwondo-content{
    width: 100%;
    padding-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/comm/components/modal/taekwondo/TaekwondoModalContent.vue